import { render, staticRenderFns } from "./invoiceBody.vue?vue&type=template&id=fe2ddc2e"
import script from "./invoiceBody.vue?vue&type=script&lang=js"
export * from "./invoiceBody.vue?vue&type=script&lang=js"
import style0 from "./invoiceBody.vue?vue&type=style&index=0&id=fe2ddc2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports